import type { ApiSession } from "../shared/contracts";

let csrfToken = "";

export class ApiRequestError extends Error {
  constructor(
    public code: string,
    message: string,
    public status: number
  ) {
    super(message);
  }
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers);
  if (options.body && !(options.body instanceof FormData)) headers.set("Content-Type", "application/json");
  if (options.method && options.method !== "GET" && csrfToken) headers.set("x-csrf-token", csrfToken);
  const response = await fetch(path, { ...options, headers, credentials: "include" });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new ApiRequestError(payload.error || "REQUEST_FAILED", payload.message || "请求失败", response.status);
  return payload as T;
}

export function setCsrfToken(value: string) {
  csrfToken = value;
}

export async function loadSession() {
  const session = await api<ApiSession>("/api/auth/session");
  setCsrfToken(session.csrfToken);
  return session;
}

export async function uploadImage(file: File) {
  const form = new FormData();
  form.append("file", file);
  return api<{ file: { id: string; name: string; size: number } }>("/api/uploads/images", { method: "POST", body: form });
}
